import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const CardItem = ({ id, name, isLiked: initialIsLiked, image, textBg, link, onToggleLike }) => {
  const [isLiked, setIsLiked] = useState(initialIsLiked);

  const handleLikeClick = (e) => {
    // Предотвращаем все возможные способы перехода
    e.preventDefault();
    e.stopPropagation();
    
    const newLikeState = !isLiked;
    setIsLiked(newLikeState);
    
    if (onToggleLike) {
      onToggleLike(id, newLikeState);
    }
    
    return false;
  };

  return (
    <div className="location-card" data-card-id={id} style={{ position: 'relative' }}>
      {/* Весь контент, кроме кнопки, оборачиваем в Link */}

      <div className="card-content" style={{ position: 'relative', height: '100%' }}>

      <Link to={link} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
        <div className="card-image-wrapper">
          <div className="card-image-container">
            <img src={image} alt={name} className="card-img" />
          </div>
        </div>

        <div className="card-bottom">
          <div className="card-text-wrapper">
            <div className="card-svg-bg">
              <img 
                src={textBg} 
                alt="" 
                className="card-svg-bg-image"
              />
            </div>
            <p className="card-title">{name}</p>
          </div>
        </div>
      </Link>

      {/* Кнопка отдельно, не внутри Link, но позиционирована абсолютно */}
      <button 
        className="favorite-btn" 
        onClick={handleLikeClick}
        onMouseDown={(e) => e.stopPropagation()} // Дополнительная защита
        aria-label={isLiked ? "Убрать из избранного" : "Добавить в избранное"}
      >
        <svg className="favorite-svg" fill="none" preserveAspectRatio="none" viewBox="0 0 60 60">
          <defs>
            <linearGradient 
              gradientUnits="userSpaceOnUse" 
              id={`paint0_${id}`} 
              x1="0" 
              x2="64.2829" 
              y1="0" 
              y2="5.00635"
            >
              <stop stopColor="#F6F6F6" stopOpacity="0.9" />
              <stop offset="0.582213" stopColor="#EDEDED" stopOpacity="0.75" />
            </linearGradient>
            <linearGradient 
              gradientUnits="userSpaceOnUse" 
              id={`paint1_${id}`} 
              x1="30" 
              x2="54.0932" 
              y1="0" 
              y2="48.4309"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="#999999" stopOpacity="0" />
            </linearGradient>
          </defs>
          <g>
            <circle 
              cx="30" 
              cy="30" 
              r="30" 
              fill={`url(#paint0_${id})`}
              fillOpacity="0.9"
            />
            <circle 
              cx="30" 
              cy="30" 
              r="29.5" 
              stroke="rgba(255, 255, 255, 0.3)"
              strokeOpacity="0.3"
            />
            <path 
              d="M15.333 26.1881C15.333 32.342 26.2421 41.906 30.333 45.6667C35.4467 41.2223 45.333 32.0001 45.333 26.1881C45.333 20.3762 40.9012 18.6667 37.833 18.6667C35.1058 18.6667 32.3785 20.3761 30.333 23.1112C28.6285 20.3761 25.9012 18.6667 22.833 18.6667C19.7648 18.6667 15.333 20.0343 15.333 26.1881Z"
              fill={isLiked ? "#C8102E" : "none"}
              stroke="black"
              strokeWidth="3"
            />
          </g>
        </svg>
      </button>
      </div>
    </div>
  );
};

export default CardItem;